'use strict';

var _extends = require('../../../node_modules/@babel/runtime/helpers/extends.js');
var objectWithoutProperties = require('../../../node_modules/@babel/runtime/helpers/objectWithoutProperties.js');
var React = require('react');
var classNames = require('classnames');
require('prop-types');
var Button = require('./Button/Button.js');
var StructuredCardButton = require('./StructuredCardButton.js');
var withStyles = require('../../../node_modules/@material-ui/core/esm/styles/withStyles.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var classNames__default = /*#__PURE__*/_interopDefaultLegacy(classNames);

var styles = function styles(theme) {
  return {
    button: {
      borderRadius: 8,
      border: '1px solid #D8D8D8',
      padding: '10px 16px',
      height: '100%',
      '&.alternate-button-selected, &:hover.alternate-button-selected': {
        backgroundColor: 'transparent',
        color: theme.palette.primary.main,
        borderColor: theme.palette.primary.main
      },
      textTransform: 'none',
      fontSize: 16,
      color: theme.palette.secondary.light,
      '&:hover': {
        color: theme.palette.black.primary
      }
    }
  };
};

var CardButton = function CardButton(_ref) {
  var classes = _ref.classes,
      title = _ref.title,
      subTitle = _ref.subTitle,
      icon = _ref.icon,
      onClick = _ref.onClick,
      selected = _ref.selected,
      className = _ref.className,
      actionIcon = _ref.actionIcon,
      actionIconText = _ref.actionIconText,
      disabled = _ref.disabled,
      noBorder = _ref.noBorder,
      noHover = _ref.noHover,
      backgroundColor = _ref.backgroundColor,
      verticalMargin = _ref.verticalMargin,
      rest = objectWithoutProperties(_ref, ["classes", "title", "subTitle", "icon", "onClick", "selected", "className", "actionIcon", "actionIconText", "disabled", "noBorder", "noHover", "backgroundColor", "verticalMargin"]);

  if (title || icon) {
    return React__default["default"].createElement(StructuredCardButton, {
      title: title,
      subTitle: subTitle,
      icon: icon,
      onClick: onClick,
      actionIcon: actionIcon,
      actionIconText: actionIconText,
      disabled: disabled,
      className: className,
      noBorder: noBorder,
      noHover: noHover,
      backgroundColor: backgroundColor,
      verticalMargin: verticalMargin
    });
  }

  var button = classes.button;
  return React__default["default"].createElement(Button["default"], _extends["default"]({
    className: classNames__default["default"](button, className, {
      'alternate-button-selected': selected
    }),
    onClick: onClick,
    fullWidth: true,
    disabled: disabled
  }, rest));
};

CardButton.defaultProps = {
  onClick: function onClick() {},
  variant: 'outlined',
  color: 'primary',
  className: '',
  subTitle: '',
  actionIconText: '',
  noBorder: false,
  noHover: false,
  backgroundColor: null,
  verticalMargin: 0
};
var CardButton$1 = withStyles(styles)(CardButton);

module.exports = CardButton$1;
